import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilesSelected = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.4776 2H17C18.6569 2 20 3.34315 20 5V13C20 14.6569 18.6569 16 17 16H3C1.34315 16 0 14.6569 0 13V3C0 1.34315 1.34315 0 3 0H8.38367C8.68571 0 8.97157 0.136521 9.16143 0.37144L10.4776 2ZM7.90609 2H3C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H17C17.5523 14 18 13.5523 18 13V5C18 4.44772 17.5523 4 17 4H10C9.69796 4 9.41209 3.86348 9.22224 3.62856L7.90609 2Z",
		fill: "#0FAFAF "
	})
});
export default SvgFilesSelected;
